/* eslint-disable */
import { REHYDRATE } from 'redux-persist';
import { THEME_PALETTE_TYPE_DARK, THEME_PALETTE_TYPE_LIGHT, THEME_PERSIST_KEY } from '../../../Constants/Theme/Theme.constants';
import themeIsLight from '../../../Support/Theme/IsLight/ThemeIsLight.support';
import { THEME_CHANGE_PALETTE, THEME_CHANGE_PALETTE_TYPE_DARK, THEME_CHANGE_PALETTE_TYPE_LIGHT, THEME_TOGGLE_PALETTE_TYPE } from './Theme.types';
import { Colors } from 'Support/Theme/Colors/Colors';

/** @typedef {Entry} State */
/** @typedef {ActionAny} ThemeActions */

/**
 * Create the state for the `themeReducer` before `redux-persist` kicks in
 * @param {Entry} entry The entry that is currently being used
 * @returns {State} The initial state before `redux-persist` kicks in
 */
const createPrePersistThemeState = ({ breakpoints, name, palette, shape, spacing, version, boralcolorspalette }) => ({
  breakpoints,
  name,
  palette,
  shape,
  spacing,
  version,
  boralcolorspalette,
});

/**
 * Create the `themeReducer`
 * @param {InjectablesForReducer} injectables The _injectable_'s required by this reducer
 * @returns {Reducer<State, ThemeActions>} The `themeReducer`
 */
const themeReducer = ({ entry }) => (state = createPrePersistThemeState(entry), action) => {
  switch (action.type) {
    case REHYDRATE: {
      if (action.key !== THEME_PERSIST_KEY || action.payload == null) {
        return state;
      }
      if (action.payload.name !== entry.name) {
        return state;
      }
      if (action.payload.version !== entry.version) {
        return state;
      }
      const { _persist, boralcolorspalette: Colors, ...newState } = action.payload;
      return newState;
    }
    case THEME_CHANGE_PALETTE: {
      return {
        ...state,
        palette: {
          ...state.palette,
          ...action.payload,
        },
      };
    }
    case THEME_CHANGE_PALETTE_TYPE_DARK: {
      return {
        ...state,
        palette: {
          ...state.palette,
          type: THEME_PALETTE_TYPE_DARK,
        },
      };
    }
    case THEME_CHANGE_PALETTE_TYPE_LIGHT: {
      return {
        ...state,
        palette: {
          ...state.palette,
          type: THEME_PALETTE_TYPE_LIGHT,
        },
      };
    }
    case THEME_TOGGLE_PALETTE_TYPE: {
      return {
        ...state,
        palette: {
          ...state.palette,
          type: themeIsLight(state.palette.type) ? THEME_PALETTE_TYPE_DARK : THEME_PALETTE_TYPE_LIGHT,
        },
      };
    }
    default: {
      return state;
    }
  }
};

export default themeReducer;
